(function () {
  const giftVariantId = Number(window.brLaunchGift && window.brLaunchGift.variantId);
  const source = 'brilian-launch-gift';
  const giftTitle = 'Lansmana özel tüm ürün tester seti';

  if (!giftVariantId || !window.routes) return;

  let syncing = false;
  let scheduledSync;

  injectStyles();

  function injectStyles() {
    if (document.getElementById('brilian-launch-gift-styles')) return;

    const style = document.createElement('style');
    style.id = 'brilian-launch-gift-styles';
    style.textContent = `
      .br-launch-gift-line .cart-item__name { color: rgb(var(--color-foreground)); }
      .br-launch-gift-pill {
        display: inline-flex;
        align-items: center;
        width: fit-content;
        min-height: 2.2rem;
        margin: .6rem 0 .2rem;
        padding: .25rem .8rem;
        border: .1rem solid rgba(var(--color-foreground), .18);
        border-radius: 8px;
        background: rgba(196, 157, 94, .14);
        color: rgb(var(--color-foreground));
        font-size: 1.1rem;
        font-weight: 700;
        line-height: 1.2;
      }
      .br-launch-gift-note {
        margin-top: .35rem;
        color: rgba(var(--color-foreground), .76);
      }
      .br-launch-gift-price {
        color: #7a5a24;
        font-weight: 800;
      }
      .br-launch-gift-line .quantity__button[disabled],
      .br-launch-gift-line .quantity__input[disabled] {
        opacity: .45;
        cursor: not-allowed;
      }
      body .product-card-wrapper .media.media--hover-effect > img {
        backface-visibility: hidden;
        transition: opacity 340ms cubic-bezier(.16, 1, .3, 1), transform 760ms cubic-bezier(.16, 1, .3, 1) !important;
        will-change: opacity, transform;
      }
      body .product-card-wrapper .media.media--hover-effect > img:first-child:not(:only-child) {
        opacity: 1 !important;
        transform: scale(1) !important;
      }
      body .product-card-wrapper .media.media--hover-effect > img + img {
        opacity: 0 !important;
        transform: scale(1.018) !important;
      }
      body .br-rhode-product__media .br-rhode-product__image {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        transition: opacity 340ms cubic-bezier(.16, 1, .3, 1), transform 820ms cubic-bezier(.16, 1, .3, 1) !important;
        will-change: opacity, transform;
      }
      body .br-rhode-product__media .br-rhode-product__image--secondary {
        object-fit: cover !important;
        object-position: center !important;
        padding: 0 !important;
        mix-blend-mode: normal !important;
      }
      body .br-rhode-product__media .br-rhode-product__image--primary,
      body .brillian-product-media .brillian-product-img-primary {
        opacity: 1 !important;
        transform: scale(1) !important;
      }
      body .br-rhode-product__media .br-rhode-product__image--secondary,
      body .brillian-product-media .brillian-product-img-secondary {
        opacity: 0 !important;
        transform: scale(1.02) !important;
      }
      @media (hover: hover) and (pointer: fine) {
        body .product-card-wrapper:hover .media.media--hover-effect > img:first-child:not(:only-child),
        body .product-card-wrapper:focus-within .media.media--hover-effect > img:first-child:not(:only-child) {
          opacity: 0 !important;
          transform: scale(1.012) !important;
        }
        body .product-card-wrapper:hover .media.media--hover-effect > img + img,
        body .product-card-wrapper:focus-within .media.media--hover-effect > img + img {
          opacity: 1 !important;
          transform: scale(1) !important;
        }
        body .br-rhode-product:hover .br-rhode-product__image--primary,
        body .br-rhode-product:focus-within .br-rhode-product__image--primary,
        body .brillian-product-card:hover .brillian-product-img-primary,
        body .brillian-product-card:focus-within .brillian-product-img-primary {
          opacity: 0 !important;
          transform: scale(1.012) !important;
        }
        body .br-rhode-product:hover .br-rhode-product__image--secondary,
        body .br-rhode-product:focus-within .br-rhode-product__image--secondary,
        body .brillian-product-card:hover .brillian-product-img-secondary,
        body .brillian-product-card:focus-within .brillian-product-img-secondary {
          opacity: 1 !important;
          transform: scale(1) !important;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        body .product-card-wrapper .media.media--hover-effect > img,
        body .br-rhode-product__media .br-rhode-product__image,
        body .brillian-product-media img {
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getCart() {
    return fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    }).then((response) => response.json());
  }

  function hasQualifyingItem(cart) {
    return cart.items.some((item) => item.variant_id !== giftVariantId && item.quantity > 0 && item.final_price > 0);
  }

  function giftItems(cart) {
    return cart.items.filter((item) => item.variant_id === giftVariantId);
  }

  function getSectionIds() {
    const sections = new Set(['cart-icon-bubble']);
    const cartDrawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      cartDrawer.getSectionsToRender().forEach((section) => sections.add(section.id));
    }

    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach((section) => sections.add(section.section || section.id));
    }

    return Array.from(sections);
  }

  function requestOptions(body) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        ...body,
        sections: getSectionIds(),
        sections_url: window.location.pathname,
      }),
    };
  }

  async function addGift() {
    const response = await fetch(
      window.routes.cart_add_url,
      requestOptions({
        items: [
          {
            id: giftVariantId,
            quantity: 1,
            properties: {
              _brilian_launch_gift: 'true',
              'Lansman hediyesi': giftTitle,
            },
          },
        ],
      })
    );

    return response.json();
  }

  async function changeGift(lineKey, quantity) {
    const response = await fetch(
      window.routes.cart_change_url,
      requestOptions({
        id: lineKey,
        quantity,
      })
    );

    return response.json();
  }

  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  function replaceCartIcon(html) {
    const target = document.getElementById('cart-icon-bubble');
    if (!target || !html) return;

    const sourceElement = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (sourceElement) target.innerHTML = sourceElement.innerHTML;

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.setHeaderCartIconAccessibility === 'function') {
      cartDrawer.setHeaderCartIconAccessibility();
    }
  }

  function renderCartDrawer(parsedState, openDrawer) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !parsedState.sections || !parsedState.sections['cart-drawer']) return;

    if (openDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(parsedState);
      return;
    }

    cartDrawer.getSectionsToRender().forEach((section) => {
      if (!parsedState.sections[section.id]) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (sectionElement) {
        sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
  }

  function renderMainCart(parsedState) {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems || !parsedState.sections || typeof cartItems.getSectionsToRender !== 'function') return;

    cartItems.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections[section.section || section.id];
      const sectionHost = document.getElementById(section.id);
      if (!sectionHtml || !sectionHost) return;

      const elementToReplace = sectionHost.querySelector(section.selector) || sectionHost;
      elementToReplace.innerHTML = getSectionInnerHTML(sectionHtml, section.selector);
    });
  }

  function renderSections(parsedState, openDrawer) {
    if (!parsedState || !parsedState.sections) return;

    renderCartDrawer(parsedState, openDrawer);
    renderMainCart(parsedState);
    replaceCartIcon(parsedState.sections['cart-icon-bubble']);
  }

  function canUsePubSub() {
    return (
      typeof subscribe === 'function' &&
      typeof publish === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    );
  }

  async function syncGift(reason, options = {}) {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();
      const gifts = giftItems(cart);
      const shouldHaveGift = hasQualifyingItem(cart);
      let latestState = null;

      if (!shouldHaveGift) {
        for (const gift of gifts) {
          latestState = await changeGift(gift.key, 0);
        }
      } else if (gifts.length === 0) {
        latestState = await addGift();
      } else {
        const [firstGift, ...extraGifts] = gifts;

        if (firstGift.quantity !== 1) {
          latestState = await changeGift(firstGift.key, 1);
        }

        for (const gift of extraGifts) {
          latestState = await changeGift(gift.key, 0);
        }
      }

      if (latestState) {
        renderSections(latestState, Boolean(options.openDrawer));

        if (canUsePubSub()) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source,
            cartData: latestState,
            reason,
          });
        }
      }
    } catch (error) {
      console.warn('The Brilian launch gift could not be synced.', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync(reason, options = {}, delay = 350) {
    window.clearTimeout(scheduledSync);
    scheduledSync = window.setTimeout(() => syncGift(reason, options), delay);
  }

  if (canUsePubSub()) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === source) return Promise.resolve();

      scheduleSync(
        'cart-update',
        {
          openDrawer: Boolean(event && event.source === 'product-form'),
        },
        450
      );

      return Promise.resolve();
    });
  }

  window.addEventListener('pageshow', () => {
    scheduleSync('pageshow', { openDrawer: false }, 700);
  });

  window.BrLaunchGift = {
    variantId: giftVariantId,
    sync: () => syncGift('manual', { openDrawer: true }),
  };
})();
